import { createBrowserRouter } from 'react-router-dom';

// project import
import MainRoutes from './MainRoutes';
import LoginRoutes from './LoginRoutes';

// ==============================|| ROUTING RENDER ||============================== //

// const lastPath = localStorage.getItem('lastPath') || window.location.pathname;

// const router = createBrowserRouter([LoginRoutes, MainRoutes], {
//     basename: import.meta.env.VITE_APP_BASE_NAME,
//     initialEntries: [lastPath], // Set the initial route
// });
const router = createBrowserRouter([LoginRoutes, MainRoutes], {
  basename: import.meta.env.VITE_APP_BASE_NAME,
  future: {
    v7_startTransition: true,
    v7_relativeSplatPath: true,
  },
});

export default router;
